import { STATE_INITIAL } from 'Store/commonActions';
import { EMAIL_AUTH_STATE_EMAIL } from 'Store/email/constants';

import type { EmailState } from './types';

const initialState: EmailState = {
  sendEmailState: STATE_INITIAL, // Email Verification
  sendEmailError: null,
  removeEmailState: STATE_INITIAL,
  sendRecoveryEmailState: STATE_INITIAL,
  emailOtpState: STATE_INITIAL,
  emailOtpError: null,
  googleTokenState: STATE_INITIAL,
  googleTokenError: null,
  emailAuthState: EMAIL_AUTH_STATE_EMAIL, // Email Auth UI Screen
  maskedEmail: '',
  otpLength: null,
  showMarketingOptIn: true,
  showStrictOptIn: true,
  checkedByDefault: false,
  secondFactorThirdParty: 'google',
};

export default initialState;
